import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-center-content',
  standalone: false,
  templateUrl: './custom-center-content.component.html',
  styleUrls: ['./custom-center-content.component.scss'],
})
export class CustomCenterContentComponent {}
